
const salesIPMock = {
  title: 'Sales',
  type: 'Sales',
  navigation: {
    type: 'GraphNavigation',
    nav: {
      month: [
        {
          title: 'LY',
          graph: {
            data: [
              {
                title: 'Sdom',
                graph: {
                  columnType: 'M',
                  data: [
                    {
                      colName: 'Jan',
                      colGroupName: 2023,
                      partial: null,
                      current: {
                        value: 633.0,
                        percent: null,
                      },
                      compare: {
                        value: 634.0,
                        percent: null,
                      },
                      isPreliminary: false,
                      isDefault: false,
                      isFuture: false,
                      cif: null,
                      kmt: null,
                    },
                    {
                      colName: 'Feb',
                      colGroupName: 2023,
                      partial: null,
                      current: {
                        value: 114.0,
                        percent: null,
                      },
                      compare: {
                        value: 113.0,
                        percent: null,
                      },
                      isPreliminary: true,
                      isDefault: true,
                      isFuture: false,
                      cif: null,
                      kmt: null,
                    },
                  ],
                },
                battery: [
                  {
                    title: 'Jan',
                    colNames: ['ACT', 'LM'],
                    columns: [
                      {
                        title: 'IP',
                        value: 29.0,
                        columns: [130.0, 0.0],
                      },
                      {
                        title: 'POTASH',
                        value: -49.0,
                        columns: [146.0, 0.0],
                      },
                      {
                        title: 'PS',
                        value: -3.0,
                        columns: [233.0, 0.0],
                      },
                      {
                        title: 'GS',
                        value: 21.0,
                        columns: [170.0, 0.0],
                      },
                    ],
                  },
                  {
                    title: 'Feb',
                    colNames: ['ACT', 'LM'],
                    columns: [
                      {
                        title: 'IP',
                        value: -5.0,
                        columns: [124.0, 0.0],
                      },
                      {
                        title: 'POTASH',
                        value: -3.0,
                        columns: [141.0, 0.0],
                      },
                      {
                        title: 'PS',
                        value: 6.0,
                        columns: [246.0, 0.0],
                      },
                      {
                        title: 'GS',
                        value: 2.0,
                        columns: [173.0, 0.0],
                      },
                    ],
                  },
                ],
              },
              {
                title: 'Potash',
                graph: {
                  columnType: 'M',
                  data: [
                    {
                      colName: 'Jan',
                      colGroupName: 2023,
                      partial: null,
                      current: {
                        value: 336.0,
                        percent: null,
                      },
                      compare: {
                        value: 634.0,
                        percent: null,
                      },
                      isPreliminary: false,
                      isDefault: false,
                      isFuture: false,
                      cif: null,
                      kmt: null,
                    },
                    {
                      colName: 'Feb',
                      colGroupName: 2023,
                      partial: null,
                      current: {
                        value: 542.0,
                        percent: null,
                      },
                      compare: {
                        value: 807.0,
                        percent: null,
                      },
                      isPreliminary: true,
                      isDefault: true,
                      isFuture: false,
                      cif: null,
                      kmt: null,
                    },
                  ],
                },
                battery: [
                  {
                    title: 'Jan',
                    colNames: ['ACT', 'LM'],
                    columns: [
                      {
                        title: 'IP',
                        value: 29.0,
                        columns: [130.0, 0.0],
                      },
                      {
                        title: 'POTASH',
                        value: -49.0,
                        columns: [146.0, 0.0],
                      },
                      {
                        title: 'PS',
                        value: -3.0,
                        columns: [233.0, 0.0],
                      },
                      {
                        title: 'GS',
                        value: 21.0,
                        columns: [170.0, 0.0],
                      },
                    ],
                  },
                  {
                    title: 'Feb',
                    colNames: ['ACT', 'LM'],
                    columns: [
                      {
                        title: 'IP',
                        value: -5.0,
                        columns: [124.0, 0.0],
                      },
                      {
                        title: 'POTASH',
                        value: -3.0,
                        columns: [141.0, 0.0],
                      },
                      {
                        title: 'PS',
                        value: 6.0,
                        columns: [246.0, 0.0],
                      },
                      {
                        title: 'GS',
                        value: 2.0,
                        columns: [173.0, 0.0],
                      },
                    ],
                  },
                ],
              },
              {
                title: 'IBP',
                graph: {
                  columnType: 'M',
                  data: [
                    {
                      colName: 'Jan',
                      colGroupName: 2023,
                      partial: null,
                      current: {
                        value: 222.0,
                        percent: null,
                      },
                      compare: {
                        value: 634.0,
                        percent: null,
                      },
                      isPreliminary: false,
                      isDefault: false,
                      isFuture: false,
                      cif: null,
                      kmt: null,
                    },
                    {
                      colName: 'Feb',
                      colGroupName: 2023,
                      partial: null,
                      current: {
                        value: 455.0,
                        percent: null,
                      },
                      compare: {
                        value: 807.0,
                        percent: null,
                      },
                      isPreliminary: true,
                      isDefault: true,
                      isFuture: false,
                      cif: null,
                      kmt: null,
                    },
                  ],
                },
                battery: [
                  {
                    title: 'Jan',
                    colNames: ['ACT', 'LM'],
                    columns: [
                      {
                        title: 'IP',
                        value: 29.0,
                        columns: [130.0, 0.0],
                      },
                      {
                        title: 'POTASH',
                        value: -49.0,
                        columns: [146.0, 0.0],
                      },
                      {
                        title: 'PS',
                        value: -3.0,
                        columns: [233.0, 0.0],
                      },
                      {
                        title: 'GS',
                        value: 21.0,
                        columns: [170.0, 0.0],
                      },
                    ],
                  },
                  {
                    title: 'Feb',
                    colNames: ['ACT', 'LM'],
                    columns: [
                      {
                        title: 'IP',
                        value: -5.0,
                        columns: [124.0, 0.0],
                      },
                      {
                        title: 'POTASH',
                        value: -3.0,
                        columns: [141.0, 0.0],
                      },
                      {
                        title: 'PS',
                        value: 6.0,
                        columns: [246.0, 0.0],
                      },
                      {
                        title: 'GS',
                        value: 2.0,
                        columns: [173.0, 0.0],
                      },
                    ],
                  },
                ],
              },
            ],
            isMainGraph: false,
          },
        },
        {
          title: 'C',
          graph: {
            data: [
                {
                  title: 'Sdom',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 633.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 114.0,
                          percent: null,
                        },
                        compare: {
                          value: 113.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
                {
                  title: 'Potash',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 336.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 542.0,
                          percent: null,
                        },
                        compare: {
                          value: 807.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
                {
                  title: 'IBP',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 222.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 455.0,
                          percent: null,
                        },
                        compare: {
                          value: 807.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
            ],
            isMainGraph: false,
          },
        },
        {
          title: 'BGT',
          graph: {
            data: [
                {
                  title: 'Sdom',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 633.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 114.0,
                          percent: null,
                        },
                        compare: {
                          value: 113.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
                {
                  title: 'Potash',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 336.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 542.0,
                          percent: null,
                        },
                        compare: {
                          value: 807.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
                {
                  title: 'IBP',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 222.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 455.0,
                          percent: null,
                        },
                        compare: {
                          value: 807.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },],
            isMainGraph: false,
          },
        },
      ],
      qtd: [
        {
            title: 'LY',
            graph: {
              data: [
                {
                  title: 'Sdom',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 633.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 114.0,
                          percent: null,
                        },
                        compare: {
                          value: 113.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
                {
                  title: 'Potash',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 336.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 542.0,
                          percent: null,
                        },
                        compare: {
                          value: 807.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
                {
                  title: 'IBP',
                  graph: {
                    columnType: 'M',
                    data: [
                      {
                        colName: 'Jan',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 222.0,
                          percent: null,
                        },
                        compare: {
                          value: 634.0,
                          percent: null,
                        },
                        isPreliminary: false,
                        isDefault: false,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                      {
                        colName: 'Feb',
                        colGroupName: 2023,
                        partial: null,
                        current: {
                          value: 455.0,
                          percent: null,
                        },
                        compare: {
                          value: 807.0,
                          percent: null,
                        },
                        isPreliminary: true,
                        isDefault: true,
                        isFuture: false,
                        cif: null,
                        kmt: null,
                      },
                    ],
                  },
                  battery: [
                    {
                      title: 'Jan',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: 29.0,
                          columns: [130.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -49.0,
                          columns: [146.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: -3.0,
                          columns: [233.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 21.0,
                          columns: [170.0, 0.0],
                        },
                      ],
                    },
                    {
                      title: 'Feb',
                      colNames: ['ACT', 'LM'],
                      columns: [
                        {
                          title: 'IP',
                          value: -5.0,
                          columns: [124.0, 0.0],
                        },
                        {
                          title: 'POTASH',
                          value: -3.0,
                          columns: [141.0, 0.0],
                        },
                        {
                          title: 'PS',
                          value: 6.0,
                          columns: [246.0, 0.0],
                        },
                        {
                          title: 'GS',
                          value: 2.0,
                          columns: [173.0, 0.0],
                        },
                      ],
                    },
                  ],
                },
              ],
              isMainGraph: false,
            },
          },
          {
            title: 'C',
            graph: {
              data: [
                  {
                    title: 'Sdom',
                    graph: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 633.0,
                            percent: null,
                          },
                          compare: {
                            value: 634.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 114.0,
                            percent: null,
                          },
                          compare: {
                            value: 113.0,
                            percent: null,
                          },
                          isPreliminary: true,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                    battery: [
                      {
                        title: 'Jan',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: 29.0,
                            columns: [130.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -49.0,
                            columns: [146.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: -3.0,
                            columns: [233.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 21.0,
                            columns: [170.0, 0.0],
                          },
                        ],
                      },
                      {
                        title: 'Feb',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: -5.0,
                            columns: [124.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -3.0,
                            columns: [141.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: 6.0,
                            columns: [246.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 2.0,
                            columns: [173.0, 0.0],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    title: 'Potash',
                    graph: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 336.0,
                            percent: null,
                          },
                          compare: {
                            value: 634.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 542.0,
                            percent: null,
                          },
                          compare: {
                            value: 807.0,
                            percent: null,
                          },
                          isPreliminary: true,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                    battery: [
                      {
                        title: 'Jan',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: 29.0,
                            columns: [130.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -49.0,
                            columns: [146.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: -3.0,
                            columns: [233.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 21.0,
                            columns: [170.0, 0.0],
                          },
                        ],
                      },
                      {
                        title: 'Feb',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: -5.0,
                            columns: [124.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -3.0,
                            columns: [141.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: 6.0,
                            columns: [246.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 2.0,
                            columns: [173.0, 0.0],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    title: 'IBP',
                    graph: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: null,
                          },
                          compare: {
                            value: 634.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 455.0,
                            percent: null,
                          },
                          compare: {
                            value: 807.0,
                            percent: null,
                          },
                          isPreliminary: true,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                    battery: [
                      {
                        title: 'Jan',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: 29.0,
                            columns: [130.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -49.0,
                            columns: [146.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: -3.0,
                            columns: [233.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 21.0,
                            columns: [170.0, 0.0],
                          },
                        ],
                      },
                      {
                        title: 'Feb',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: -5.0,
                            columns: [124.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -3.0,
                            columns: [141.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: 6.0,
                            columns: [246.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 2.0,
                            columns: [173.0, 0.0],
                          },
                        ],
                      },
                    ],
                  },
              ],
              isMainGraph: false,
            },
          },
          {
            title: 'BGT',
            graph: {
              data: [
                  {
                    title: 'Sdom',
                    graph: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 633.0,
                            percent: null,
                          },
                          compare: {
                            value: 634.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 114.0,
                            percent: null,
                          },
                          compare: {
                            value: 113.0,
                            percent: null,
                          },
                          isPreliminary: true,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                    battery: [
                      {
                        title: 'Jan',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: 29.0,
                            columns: [130.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -49.0,
                            columns: [146.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: -3.0,
                            columns: [233.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 21.0,
                            columns: [170.0, 0.0],
                          },
                        ],
                      },
                      {
                        title: 'Feb',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: -5.0,
                            columns: [124.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -3.0,
                            columns: [141.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: 6.0,
                            columns: [246.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 2.0,
                            columns: [173.0, 0.0],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    title: 'Potash',
                    graph: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 336.0,
                            percent: null,
                          },
                          compare: {
                            value: 634.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 542.0,
                            percent: null,
                          },
                          compare: {
                            value: 807.0,
                            percent: null,
                          },
                          isPreliminary: true,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                    battery: [
                      {
                        title: 'Jan',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: 29.0,
                            columns: [130.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -49.0,
                            columns: [146.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: -3.0,
                            columns: [233.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 21.0,
                            columns: [170.0, 0.0],
                          },
                        ],
                      },
                      {
                        title: 'Feb',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: -5.0,
                            columns: [124.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -3.0,
                            columns: [141.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: 6.0,
                            columns: [246.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 2.0,
                            columns: [173.0, 0.0],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    title: 'IBP',
                    graph: {
                      columnType: 'M',
                      data: [
                        {
                          colName: 'Jan',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 222.0,
                            percent: null,
                          },
                          compare: {
                            value: 634.0,
                            percent: null,
                          },
                          isPreliminary: false,
                          isDefault: false,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                        {
                          colName: 'Feb',
                          colGroupName: 2023,
                          partial: null,
                          current: {
                            value: 455.0,
                            percent: null,
                          },
                          compare: {
                            value: 807.0,
                            percent: null,
                          },
                          isPreliminary: true,
                          isDefault: true,
                          isFuture: false,
                          cif: null,
                          kmt: null,
                        },
                      ],
                    },
                    battery: [
                      {
                        title: 'Jan',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: 29.0,
                            columns: [130.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -49.0,
                            columns: [146.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: -3.0,
                            columns: [233.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 21.0,
                            columns: [170.0, 0.0],
                          },
                        ],
                      },
                      {
                        title: 'Feb',
                        colNames: ['ACT', 'LM'],
                        columns: [
                          {
                            title: 'IP',
                            value: -5.0,
                            columns: [124.0, 0.0],
                          },
                          {
                            title: 'POTASH',
                            value: -3.0,
                            columns: [141.0, 0.0],
                          },
                          {
                            title: 'PS',
                            value: 6.0,
                            columns: [246.0, 0.0],
                          },
                          {
                            title: 'GS',
                            value: 2.0,
                            columns: [173.0, 0.0],
                          },
                        ],
                      },
                    ],
                  },],
              isMainGraph: false,
            },
          },
      ],
    },
  },
  subMenu: [
    {
      // NavigationItem
      title: 'Sdom'
    },
    {
      // NavigationItem
      title: 'Potash',
    },
    {
        // NavigationItem
        title: 'IBP',
    },
  ],
};
const oiIPMock = {
    "title": "OI",
    "type": "OI",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 31.0,
                                                "percent": -50.0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": -45.0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 17.0,
                                                "percent": -63.0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 26.0,
                                                "percent": -39.0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": -54.0
                                            },
                                            "compare": {
                                                "value": 11.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": -58.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 8.0,
                                                "percent": 123.0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 31.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 31.0,
                                                "percent": -7.0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": -2.0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 17.0,
                                                "percent": -34.0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 26.0,
                                                "percent": 8.0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": 21.0
                                            },
                                            "compare": {
                                                "value": 11.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 8.0,
                                                "percent": 177.0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 63.0,
                                                "percent": -48.0
                                            },
                                            "compare": {
                                                "value": 120.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 188.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 191.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 154.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 95.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": -52.0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 143.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 75.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": -56.0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 28.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                
            ],
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'BR',
        },
        {
          // NavigationItem
          title: 'P',
        },
        {
            // NavigationItem
            title: 'SM',
        },
      ],
};
const ebitdaIPMock = {
    "title": "EBITDA",
    "type": "EBITDA",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 31.0,
                                                "percent": -50.0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": -45.0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 17.0,
                                                "percent": -63.0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 26.0,
                                                "percent": -39.0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": -54.0
                                            },
                                            "compare": {
                                                "value": 11.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": -58.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 8.0,
                                                "percent": 123.0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": -31.0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -63.0,
                                                "columns": [
                                                    17.0,
                                                    47.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -54.0,
                                                "columns": [
                                                    5.0,
                                                    11.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 123.0,
                                                "columns": [
                                                    8.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -39.0,
                                                "columns": [
                                                    26.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -58.0,
                                                "columns": [
                                                    4.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -31.0,
                                                "columns": [
                                                    4.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    54.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    52.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    53.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    43.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    49.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    8.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    35.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    6.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 31.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 26.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -40.0,
                                                "columns": [
                                                    17.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -1773.0,
                                                "columns": [
                                                    5.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 49.0,
                                                "columns": [
                                                    8.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 50.0,
                                                "columns": [
                                                    26.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -10.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": -50.0,
                                                "columns": [
                                                    4.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    0.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 31.0,
                                                "percent": -7.0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": -2.0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 68.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 67.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 56.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 59.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 55.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 32.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 17.0,
                                                "percent": -34.0
                                            },
                                            "compare": {
                                                "value": 47.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 26.0,
                                                "percent": 8.0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 54.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 52.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 53.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 43.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 49.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 35.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 27.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 5.0,
                                                "percent": 21.0
                                            },
                                            "compare": {
                                                "value": 11.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 8.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 0.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 8.0,
                                                "percent": 177.0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 4.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 5.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 4.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 2.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 3.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 6.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -34.0,
                                                "columns": [
                                                    17.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 21.0,
                                                "columns": [
                                                    5.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 177.0,
                                                "columns": [
                                                    8.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 8.0,
                                                "columns": [
                                                    26.0,
                                                    24.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -13.0,
                                                "columns": [
                                                    4.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 4.0,
                                                "columns": [
                                                    4.0,
                                                    4.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    27.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    26.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    31.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    5.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    2.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    4.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    3.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 63.0,
                                                "percent": -48.0
                                            },
                                            "compare": {
                                                "value": 120.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 188.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 191.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 154.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 95.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BR",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": -52.0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 143.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 149.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 125.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 75.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "P",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 9.0,
                                                "percent": -56.0
                                            },
                                            "compare": {
                                                "value": 21.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 33.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 29.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 7.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SM",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 12.0,
                                                "percent": 28.0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 10.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 12.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": -52.0,
                                                "columns": [
                                                    43.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": -56.0,
                                                "columns": [
                                                    9.0,
                                                    21.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 28.0,
                                                "columns": [
                                                    12.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    143.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    33.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    149.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    29.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    125.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    10.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BR",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    75.0
                                                ]
                                            },
                                            {
                                                "title": "P",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    7.0
                                                ]
                                            },
                                            {
                                                "title": "SM",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    12.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                
            ],
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'BR',
        },
        {
          // NavigationItem
          title: 'P',
        },
        {
            // NavigationItem
            title: 'SM',
        },
      ],
};

export const IPGraphsMock = [
    salesIPMock,
    oiIPMock,
    ebitdaIPMock
];